var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99609 16.6665C12.3961 11.3332 19.5961 11.3332 21.9961 16.6665",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9961 19.333C14.8915 19.333 13.9961 18.4376 13.9961 17.333C13.9961 16.2284 14.8915 15.333 15.9961 15.333C17.1007 15.333 17.9961 16.2284 17.9961 17.333C17.9961 18.4376 17.1007 19.333 15.9961 19.333Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.523c17412cb9392c0b495981f187970e.svg";
export { ForwardRef as ReactComponent };